import React, { memo } from 'react';
import classNames from 'classnames';
import { Box, Link, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Avatar from '../Avatar/Avatar';
import { formatPositionAtCompany } from '../../modules/RecipientModule/helpers/recipient.helpers';
import { TFullSender } from '../../store/users/users.types';

const useStyles = makeStyles(({ palette, spacing }) => ({
  info: {
    wordBreak: 'break-word',
  },
  avatar: {
    width: 64,
    height: 64,
    marginRight: spacing(2),
  },
  position: {
    color: `${palette.text.primary} !important`,
  },
}));

export interface IGiftSenderInfoProps {
  sender: TFullSender | null;
}

const SenderInfo = ({ sender }: IGiftSenderInfoProps) => {
  const classes = useStyles();

  const jobDesc = formatPositionAtCompany(sender || {});

  return (
    <Box
      display="flex"
      justifyContent="flex-start"
      alignItems="center"
      borderTop={1}
      borderColor="border.grey"
      mt={3}
      pt={2.5}
    >
      <Avatar className={classes.avatar} src={sender?.image ?? ''} alt="Sender avatar" />
      <Box className={classes.info}>
        <Box
          data-testid="giftSenderName"
          color="text.primary"
          fontWeight={800}
          textAlign="left"
          fontSize={16}
          fontFamily="Lato"
        >
          {sender?.fullName}
        </Box>
        <Box textAlign="left" data-testid="giftSenderPosition">
          <Typography className={classNames('Body-Regular-Left-Static', classes.position)}>{jobDesc}</Typography>
        </Box>
        <Box data-testid="giftSenderEmail" textAlign="left" fontSize={16} fontFamily="Lato">
          <Link href={`mailto:${sender?.email}`} underline="hover">
            {sender?.email}
          </Link>
        </Box>
        {sender?.phone && (
          <Box data-testid="giftSenderPhone" textAlign="left" fontSize={16} fontFamily="Lato">
            <Link href={`tel:${sender?.phone}`} underline="hover">
              {sender?.phone}
            </Link>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default memo(SenderInfo);
